import {ButtonAppearance, ButtonControlValues, ButtonSize, ButtonStyle} from "../../atoms/rentware-button/types";
import {Article} from "./types";
import {BookingDetails, Cart, CartItem} from "../../../redux/types";

export const buttonAppearance = (article: Article): ButtonAppearance => {
    return article.available ? {
        fullWidth: true,
        size: ButtonSize.XL,
    } : {
        style: ButtonStyle.Inverse,
        fullWidth: true,
        disabled: true,
        size: ButtonSize.XL,
    };
}

export const buttonControlValues = (article: Article): ButtonControlValues => {
    return article.available && {
        id: article.id,
        minQuantity: article.minAmount,
        maxQuantity: article.amount + article.availableAmount,
        currentQuantity: article.amount,
        onChange: article.onChangeAmountToBook,
    };
}

export const thisItemInCart = (itemId: string, cart: Cart): CartItem => {
    return cart?.items.find((item) => item.itemId === itemId && !item.isMileageOption);
}

export const mileageIdInBookingDetails = (mileageId: string, bookingDetails: BookingDetails): string => {
    return bookingDetails.selectedMileageIds[mileageId]
}

export const variationIdInBookingDetails = (variationId: string, bookingDetails: BookingDetails): string => {
    return bookingDetails.selectedVariationIds[variationId]
}
